<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-tab
        :dense="true"
        :tabItems="tabItems"
        :height="tabHeight"
        :inlineLabel="true"
        v-model="tab"
        @tabClick="tabClick"
      >
        <template v-slot:default="tab">
          <component
            :count="count"
            :popupParam="popupParam"
            :tabParam="tabParam"
            :is="tab.component"
            @transInfo="transInfo"
            @closePopup="closePopup"
            @changeStatus="changeStatus"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>
<script>
import { uid } from 'quasar'
export default {
  name: 'hazard-equipment-class-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        hhmHazardousMachineryId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tabDisabled: false,
      tab: 'hazardEquipmentInfo',
      addTabItems: [],
      tabItems: [],
      tabParam: {
        hhmHazardousMachineryId: '',
        equipmentCd: '',
        hazardEquipmentHistoryModels: [],
        equipmentImproveModels: [],
      },
      count: 0,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 45);
    },
  },
  watch: {
  },
  methods: {
    init() {
      this.tabItems = [
        { name: 'hazardEquipmentInfo', icon: 'info', label: '유해위험기계기구 정보', component: () => import(`${'./hazardEquipmentInfo.vue'}`), key: uid()  },
      ]
      this.addTabItems = [
        { name: 'hazardEquipmentHistory', icon: 'construction', label: '안전검사 이력관리', component: () => import(`${'./hazardEquipmentHistory.vue'}`), key: uid()  },
        { name: 'hazardFocusHistory', icon: 'highlight_alt', label: '중점점검 이력', component: () => import(`${'./hazardEquipmentFocusHistory.vue'}`), key: uid()  },
        { name: 'hazardCausePrevention', icon: 'add_circle_outline', label: '방지 및 감소대책', component: () => import(`${'./hazardCausePrevention.vue'}`), key: uid()  },
      ]
      if (this.popupParam.hhmHazardousMachineryId) {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    transInfo(data) {
      this.tabParam = data
    },
    changeStatus() {
      this.tabItems = this.tabItems.concat(this.addTabItems);
    },
    closePopup() {
      this.$emit('closePopup')
    },
    tabClick() {
      this.count++;
    }
  }
};
</script>